import { Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import forgot from "../../assets/images/icon_login/forgot-password.svg";
import { checkOTP, forgotPassword } from "../../core/service/api_profile";
import TabsMobile from "../__template/TabsMobileComponent";
import Countdown, { zeroPad } from "react-countdown";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import moment from "moment";
import { toast } from "react-toastify";

const ComponentForgotPasswordOTP = () => {
  const { t } = useTranslation();
  const [otp, setOtp] = useState("");
  const [data, setData] = useState<any>({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location: any = useLocation();

  const [timer, setTimer] = useState(0);
  const [countdown, setCountdown] = useState(false);
  const [stopCountdown, setStopCountdown] = useState(false);

  const funCheckOTP = async () => {
    if (otp == "") return toast.warning(t("FORGOT-PASSWORD-OTP.enterCode"));
    if (otp.length < 5 || otp.length > 5)
      return toast.warning(t("FORGOT-PASSWORD-OTP.invalid"));

    var query: any = { newPassword: "", otp: otp, phoneEmail: data.phoneEmail };
    checkOTP(query)
      .then((res) => {
        query.sendVia = data.sendVia;
        query.reqTime = data.reqTime;

        navigate("/forgot-password-create", {
          state: { data: JSON.stringify(query) },
        });
      })
      .catch((err: any) => {
        console.log(err.data.message, "err");
      });
  };

  const renderer = (
    // { hours, minutes, seconds, completed }
    data: any
  ) => {
    if (data.completed) {
      setCountdown(false);
      return (
        <button
          className="text-psp-primary font-medium text-center text-sm font-montserrat"
          onClick={() => {
            setOtp("");
            setTimer(Date.now() + 300000);
            resendOtp();
          }}
        >
          Kirim Ulang
        </button>
      );
    } else {
      setCountdown(true);
      // Render a countdown
      return (
        <span className="text-psp-nav font-medium text-center text-sm font-montserrat">
          {zeroPad(data.minutes)}:{zeroPad(data.seconds)}
        </span>
      );
    }
  };

  const resendOtp = async () => {
    var query = {
      newPassword: "",
      otp: "",
      phoneEmail: data.phoneEmail,
      sendVia: data.sendVia,
      reqTime: data.reqTime,
    };
    setOtp("");
    dispatch(setLoading(true));
    forgotPassword(query)
      .then((res) => {
        dispatch(setLoading(false));
        setCountdown(false);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
      });
  };

  useEffect(() => {
    setTimer(Date.now() + 300000);
    setCountdown(false);
    setData(JSON.parse(location?.state?.data));
    console.log(JSON.parse(location?.state?.data));
  }, []);
  return (
    <div className="min-h-screen h-full px-10 py-7 bg-psp-primary">
      <TabsMobile
        name={`${t("FORGOT-PASSWORD.title")}`}
        backUrl={"login"}
      ></TabsMobile>

      <section className="flex flex-col mt-14">
        <h1 className="font-montserrat m-0 font-bold text-sm text-black text-center">
          {t("FORGOT-PASSWORD-OTP.subtitle")}
        </h1>
        <p className="font-montserrat mt-2 font-medium text-xs text-black text-center">
          {t("FORGOT-PASSWORD-OTP.description")}
        </p>
        <h1 className="font-montserrat m-0 font-bold text-sm text-black text-center">
          {t("FORGOT-PASSWORD-OTP.enterCode")}
        </h1>
        <input
          type={"number"}
          onChange={(e) => setOtp(e.target.value)}
          maxLength={5}
          className="px-3 py-2.5 rounded-lg lining-nums font-montserrat font-medium tracking-wide text-center my-2"
        ></input>
        <Countdown key={timer} date={timer} renderer={renderer} />

        <hr />
        <button
          onClick={() => funCheckOTP()}
          className="mt-2 bg-psp-btn-primary text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
        >
          {t("FORGOT-PASSWORD-OTP.confirm")}
        </button>
      </section>
    </div>
  );
};

export default ComponentForgotPasswordOTP;
